module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "comHeader"
    }
  }, [_c('img', {
    staticClass: "iconImg",
    attrs: {
      "src": require("../assets/icon.png"),
      "alt": "icon"
    }
  }), _vm._v(" "), (_vm.title !== null) ? _c('p', {
    staticClass: "title",
    on: {
      "click": _vm.showEditTitleModal
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        "), _c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [(_vm.links.indexOf('hotkey') > -1) ? _c('div', {
    staticClass: "link hotkey",
    on: {
      "click": _vm.showHotkey
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.links.indexOf('list') > -1) ? _c('div', {
    staticClass: "link toListBtn",
    on: {
      "click": _vm.toListPage
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "link signOutBtn",
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "confirm",
      "modalId": "signOutModal",
      "title": "確認登出?"
    },
    on: {
      "confirm": _vm.confirmSignOut
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "input",
      "modalId": "editTitleModal",
      "title": "請輸入歌曲名稱",
      "ok-title": "更新",
      "emptyInputAlert": "歌曲名稱請勿空白",
      "defaultInput": _vm.title
    },
    on: {
      "confirm": _vm.confirmEditTitle
    }
  }), _vm._v(" "), _c('com-modal', {
    attrs: {
      "modalType": "preview",
      "modalId": "hotkeyModal"
    }
  }, [_c('div', {
    staticClass: "hotkeyIntro",
    attrs: {
      "slot": "modalContent"
    },
    slot: "modalContent"
  }, [_c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("Enter")]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("確認複製選取範圍")])]), _vm._v(" "), _c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("ESC")]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("離開圖片複製模式")])]), _vm._v(" "), _c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_vm._v("SPACE")]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("播放/暫停")])]), _vm._v(" "), _c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_c('i', {
    staticClass: "fa fa-caret-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("上一頁")])]), _vm._v(" "), _c('div', {
    staticClass: "hotkey"
  }, [_c('div', {
    staticClass: "key"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v("下一頁")])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d55585c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/com-header.vue
// module id = 197
// module chunks = 2